import { useEffect, useRef, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { LanguageContext } from "@/lang";
import { translations } from "@/i18n";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import LegalPage from "@/pages/Legal";
import Admin from "@/pages/Admin";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Strategy from "@/components/Strategy";
import Stats from "@/components/Stats";
import Partners from "@/components/Partners";
import Hardware from "@/components/Hardware";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";
import PageTracker from "@/components/PageTracker";

const Home = () => (
  <main>
    <Hero />
    <Marquee />
    <Services />
    <Strategy />
    <Stats />
    <Partners />
    <Hardware />
    <Contact />
  </main>
);

function App() {
  const [lang, setLang] = useState("fr");
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  const scrollTo = (target) => {
    if (lenisRef.current) {
      lenisRef.current.scrollTo(target, { offset: -72, duration: 1.5 });
    }
  };

  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, scrollTo }}>
      <div className="min-h-screen bg-white text-slate-900" data-testid="beintec-app">
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/mentions-legales" element={<LegalPage type="legal" />} />
            <Route path="/politique-confidentialite" element={<LegalPage type="privacy" />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Footer />
          <PageTracker />
          <CookieBanner />
        </BrowserRouter>
      </div>
    </LanguageContext.Provider>
  );
}

export default App;
